<template>
  <div class="justify-content-center align-items-center d-flex flex-row w-100">
    <input
      class="col-10 pr-0 form-control"
      style="text-overflow: ellipsis; border-radius: 0!important"
      id="textField"
      v-model="model.url"
      readonly
    >
    <div>
      <Button
        icon="uil-copy"
        class="btn btn-primary col-2"
        title="Copy URL"
        style="padding: 8px 20px!important; border-radius: 0!important;"
        @click="onCopyUrl(model.url)"
      />
    </div>
  </div>
</template>

<script>
// import TextField from '@components/form/textfield.vue'
import Button from '@components/buttons'

export default {
  components: {
    // TextField,
    Button
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      model: {
        url: ''
      }
    }
  },
  computed: {
    job_url() {
      let parameters = this.parameters || {}
      return parameters.job_url
    }
  },
  methods: {
    onCopyUrl() {
      let textField = document.getElementById('textField')
      textField.select()

      document.execCommand('copy')
    }
  },
  mounted() {
    this.model = { url: this.job_url }
    console.log(this.job_url)
  },
}
</script>